<template>
  <div class="podcast-accordion expanded">
    <div class="podcast-header">
      <div class="podcast-title">
        <span class="podcast-icon">🎧</span>
        <h3>Podcast da Aula</h3>
      </div>
    </div>
    <div class="podcast-content">
      <vue-plyr ref="plyr" :options="playerOptions" :key="plyrKey">
        <audio @play="onPlay">
          <source :src="audioSrc" type="audio/mp3" />
          Seu navegador não suporta áudio.
        </audio>
      </vue-plyr>
      <p class="description">
        Ouça o resumo e comentários extras desta aula em formato de podcast.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "PodcastPlayer",
  props: {
    audioSrc: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      player: null,
      playerOptions: {
        speed: {
          selected: 1,
          options: [0.5, 1, 1.5, 1.75, 2, 2.5],
        },
        controls: [
          "play-large",
          "play",
          "progress",
          "current-time",
          "mute",
          "volume",
          "speed",
          "settings",
        ],
      },
      plyrKey: 0,
    };
  },
  watch: {
    audioSrc: {
      handler(newSrc) {
        if (this.player && newSrc) {
          this.player.pause();
          this.player.source = {
            type: "audio",
            sources: [
              {
                src: newSrc,
                type: "audio/mp3",
              },
            ],
          };
          this.$nextTick(() => {
            setTimeout(() => {
              if (this.player) {
                this.player.play().catch(() => {});
              }
            }, 100);
          });
        }
        this.plyrKey += 1;
      },
      immediate: true,
    },
  },
  mounted() {
    if (this.$refs.plyr && this.$refs.plyr.player) {
      this.player = this.$refs.plyr.player;
      this.player.on("play", () => {
        this.$emit("podcast-play");
      });
    }
  },
  methods: {
    onPlay() {
      this.$emit("podcast-play");
    },
    pause() {
      if (this.player) {
        this.player.pause();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.podcast-accordion {
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin: 1rem auto;
  border-left: 4px solid var(--v-primary-lighten1);
  width: calc(100% - 40px);
  max-width: 500px;
}

.podcast-header {
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgba(99, 102, 241, 0.05);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.podcast-title {
  display: flex;
  align-items: center;
}

.podcast-icon {
  font-size: 1.2rem;
  margin-right: 0.8rem;
}

.podcast-title h3 {
  margin: 0;
  font-size: 1.1rem;
}

.podcast-content {
  padding: 1.5rem;
}

.podcast-content .vue-plyr {
  width: 100%;
  margin-bottom: 1rem;
}

.podcast-content .description {
  font-size: 0.9rem;
  margin: 0;
}

@media (max-width: 600px) {
  .podcast-accordion {
    width: calc(100% - 32px);
    max-width: 100%;
    margin: 1rem auto;
  }

  .podcast-content {
    padding: 0 16px !important;
  }

  .podcast-content .vue-plyr {
    --plyr-control-spacing: 10px;
    --plyr-control-icon-size: 14px;
  }
}

::v-deep .plyr {
  border-radius: 0;
}

::v-deep .plyr--audio {
  border-radius: 0;
}

::v-deep .plyr__controls {
  border-radius: 0;
}

::v-deep .plyr__progress__container {
  border-radius: 0;
}

::v-deep .plyr__volume {
  border-radius: 0;
}

::v-deep .plyr__control {
  border-radius: 0;
}
</style>
